import Icon from '../components/Icon.vue'

Icon.register({
  qrcode: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M0 224v-192h192v192h-192zM64 96v64h64v-64h-64zM256 32h192v192h-192v-192zM384 160v-64h-64v64h64zM0 480v-192h192v192h-192zM64 352v64h64v-64h-64zM416 288h32v128h-96v-32h-32v96h-64v-192h96v32h64v-32zM416 448h32v32h-32v-32zM352 448h32v32h-32v-32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/qrcode.js
// module id = 1668
// module chunks = 0